import { map } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatModels from '@medsurf/flat-models';

@Injectable()
export class AppSharedFacade {

  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">
  
  apiVersion$ = this.store.select(FlatStates.GeneralControlState.apiVersion$);
  currentUser$ = this.store.select(FlatStates.AuthControlState.currentUser$);
  metadata$ = this.store.select(FlatStates.MetadataEntityState.metadata);
  themeColor$ = this.store.select(FlatStates.PageEntityState.themeColor$);
  currentSelectedBreadcrumbs$ = this.store.select(FlatStates.PageEntityState.currentSelectedBreadcrumbs$); // author
  currentNodeBreadcrumbs$ = this.store.select(FlatStates.PageEntityState.currentNodeBreadcrumbs$); // viewer
  currentSelectedSlideTitle$ = this.store.select(FlatStates.PageEntityState.currentSelectedSlideTitle$);

  //</editor-fold>
  
  snapshot_metadata = () => this.store.selectSnapshot(FlatStates.MetadataEntityState.metadata);
  snapshot_currentSelectedSlideTitle = () => this.store.selectSnapshot(FlatStates.PageEntityState.currentSelectedSlideTitle$);
  
  //<editor-fold desc="Lazy Selectors">
  
  canWriteNode$ = (id?: string) => this.store.select(FlatStates.NodeEntityState.canWriteNode$).pipe(map(filterFn => filterFn(id)));
  canReadNode$ = (nodeId?: string) => this.store.select(FlatStates.NodeEntityState.canReadNode$).pipe(map(filterFn => filterFn(nodeId)));
  user$ = (id: any) => this.store.select(FlatStates.UserEntityState.entity$).pipe(map(filterFn => filterFn(id as unknown as string)));
  page$ = (id: any) => this.store.select(FlatStates.PageEntityState.entity$).pipe(map(filterFn => filterFn(id as unknown as string)));
  pages$ = (ids: any) => this.store.select(FlatStates.PageEntityState.entitiesByIds$).pipe(map(filterFn => filterFn(ids as unknown as string[])));
  routeElement$ = (id: any) => this.store.select(FlatStates.NodeEntityState.routeElement$).pipe(map(filterFn => filterFn(id as unknown as string)));
  copyright$ = (id: any) => this.store.select(FlatStates.CopyrightEntityState.entity$).pipe(map(filterFn => filterFn(id as unknown as string)));
  media$ = (id: any) => this.store.select(FlatStates.MediaEntityState.entity$).pipe(map(filterFn => filterFn(id as unknown as string)));
  modality$ = (id: any) => this.store.select(FlatStates.ModalityEntityState.entity$).pipe(map(filterFn => filterFn(id as unknown as string)));


  //</editor-fold>

  //<editor-fold desc="Requests">
  
  requestGetApiVersion() {
    return this.store.dispatch(new FlatActions.GeneralControlActions.GetApiVersion());
  }

  requestMe() {
    return this.store.dispatch(new FlatActions.AuthControlActions.Me());
  }

  requestMetadata() {
    return this.store.dispatch(new FlatActions.MetadataControlActions.GetMetadata());
  }

  requestUpdateMetadata(metadata: FlatModels.MetadataEntityModels.Metadata) {
    return this.store.dispatch(new FlatActions.MetadataEntityActions.UpdateEntity(metadata));
  }

  //</editor-fold>
}
